import {Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {IVersionDetails} from "../../versiont.details/interfaces/version.details";
import {VersionDetailsService} from "../../versiont.details/services/version.details.service";
import {ProductLabelingState} from "../../versiont.details/interfaces/product.labeling.state";
import {PopupWindowService} from "../../services/popup.window.service";
import {OtherCountryLabelComponent} from "./other.country.label.component";
import {takeUntilDestroy} from "take-until-destroy";

@Component({
  selector: 'app-about-page',
  templateUrl: './about.page.template.html',
  styleUrls: ['./about.page.style.scss']
})
export class AboutPageComponent implements OnInit, OnDestroy{

  @Output() close = new EventEmitter();

  @ViewChild('otherCountryLabelTitle', { static: true, read: TemplateRef }) otherCountryLabelTitle: TemplateRef<any>;

  public productName = 'Workflow Information Management';
  public readonly copyrightYear = 2025;
  public commercialVersion: string;
  public internalVersion: string;
  public commonVersion: string;
  public releaseVersion: string;
  public productCodeNumber = 839110;
  public buildDate: string;
  public buildDateUDI: string;
  public acknowledgement3rdUrl: string;
  public isUnreleasedDevice: boolean;
  public isNonMedicalDevice: boolean;
  public buildNumber: string;

  constructor(private versionDetailsService: VersionDetailsService,
              public popupWindowService: PopupWindowService) {
  }

  ngOnInit(): void {

    const versionDetails: IVersionDetails =  this.versionDetailsService.getVersionDetails();
    this.commercialVersion = versionDetails.commercialVersion;
    this.internalVersion = versionDetails.internalVersion;
    this.buildDate =   this.getFormattedBuildDate(versionDetails.buildDate);
    this.buildDateUDI = this.getFormattedBuildDateUDI(versionDetails.buildDate);

    let commercialVersionParts = versionDetails.commercialVersion.split('.');
    let internalVersionParts = versionDetails.internalVersion.split('.');

    this.commonVersion = commercialVersionParts[0];
    this.releaseVersion =  `${commercialVersionParts[0]}.${commercialVersionParts[1]}`;
    this.buildNumber =  internalVersionParts[3];

    this.productName += ` ${this.commonVersion}`;

    if (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice) {
      this.productName += " (WIP)";
    }

    this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
    this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
  }

  ngOnDestroy() {
  }

  openUkImporterPopup() {
    this.popupWindowService.openPopupWindow(OtherCountryLabelComponent,
      this.otherCountryLabelTitle, 'other-country-label-title', 400, 300 )
      .pipe(takeUntilDestroy(this))
      .subscribe();
  }

  private getFormattedBuildDate(buildDate: Date): string {
    return buildDate.getFullYear() + "-"
      +  this.padDatePart(buildDate.getMonth() + 1) + "-"
      + this.padDatePart(buildDate.getDate());
  }

  private getFormattedBuildDateUDI(buildDate: Date): string {
    const year = buildDate.getFullYear().toString().substr(2);
    const month = this.padDatePart(buildDate.getMonth() + 1);
    const day = this.padDatePart(buildDate.getDate());

    return year + month + day;
  }

  private padDatePart(datePart: number) {

    const datePartStr = datePart.toString();
    if (datePartStr.length === 1){
      return "0" + datePartStr;
    }
    return datePartStr;
  }


}
